<template>
  <div id="key">
    <KeyStats v-if="$store.state.showKeyStats" />
    <div v-if="collapsed">
      <span class="float-right clickable mr-2"><i @click="collapsed = false" class="fas fa-angle-up collapse-button"></i></span>
      <p @click="collapsed = false" class="clickable mb-0 text-center"><strong>Key</strong></p>
    </div>
    <div v-else>
      <span v-if="!heatMap && $store.state.dataset.vizSettings && $store.state.dataset.vizSettings.colorBy === 'valueBased'" class="float-left clickable mr-2"><i @click="showKeyStats($store.state.dataset.vizSettings.minValue, $store.state.dataset.vizSettings.maxValue, 'Dataset Stats', $store.state.keyStatsTotalArea)" class="fas fa-info-circle"></i></span>
      <span class="float-right clickable mr-2"><i @click="collapsed = true" class="fas fa-angle-down collapse-button"></i></span>
      <!-- <p
        v-if="!heatMap && $store.state.dataset.vizSettings && $store.state.dataset.vizSettings.colorBy === 'valueBased'"
        class="mb-1 text-center"
      ><strong>{{ $store.state.dataset.vizSettings.colorHeader }}</strong></p> -->
      <p
        class="mb-1 text-center"
      ><strong>{{ title }}</strong></p>
      <!-- POINT MAP CATEGORICAL -->
      <div
        v-if="mode === 'categorical' && !heatMap"
        class="color-dot"
      >
        <p
          v-for="(item, i) in items"
          v-bind:key="i"
          class="mb-0"
        ><i :style="'color:' + item.color +';'" class="fas fa-circle"></i> {{ item.label }}</p>
      </div>
      <!-- HEAT MAP -->
      <div
        v-if="heatMap"
        class="color-dot"
      >
        <p
          class="mb-0"
        ><span class="heat-dot"></span> Datapoints</p>
      </div>
      <!-- RAMP GRADIENT -->
      <div
        v-if="mode === 'ramp'"
        class="color-ramp"
      >
        <div
          class="color-ramp-bar"
          :style="'width:100%;background:linear-gradient(90deg, ' + items[0].color + ' 0%, ' + items[1].color + ' 100%);'"
        ></div>
        <p class="mb-0" v-if="!isTimeHeader"><span class="mr-4">{{ minValue | toFixed }}</span>
        <span class="float-right">{{ maxValue | toFixed }}</span></p>
        <p class="mb-0" v-if="isTimeHeader"><span class="mr-4">{{ minValue | toDate }}</span>
        <span class="float-right">{{ maxValue | toDate }}</span></p>
      </div>
      <!-- ZONES -->
      <div v-if="mode === 'zones'">
        <b-table responsive :items="items" :fields="fields">
          <template #cell(color)="data">
            <div @click="showKeyStats(items[data.index].min, items[data.index].max, 'Zone ' + (data.index + 1) + ' Stats', items[data.index].area)" class="dot clickable" :style="'background-color:' + data.value +';'"></div>
          </template>
          <template #cell(label)="data">
            <span class="clickable" @click="showKeyStats(items[data.index].min, items[data.index].max, 'Zone ' + (data.index + 1) + ' Stats', items[data.index].area)">{{ data.value }}</span>
          </template>
          <template #cell(min)="data">
            <span v-if="!isTimeHeader" class="clickable" @click="showKeyStats(items[data.index].min, items[data.index].max, 'Zone ' + (data.index + 1) + ' Stats', items[data.index].area)">{{ data.value | toFixedSmall }}</span>
            <span v-if="isTimeHeader" class="clickable" @click="showKeyStats(items[data.index].min, items[data.index].max, 'Zone ' + (data.index + 1) + ' Stats', items[data.index].area)">{{ data.value | toDate }}</span>
          </template>
          <template #cell(max)="data">
            <span v-if="!isTimeHeader" class="clickable" @click="showKeyStats(items[data.index].min, items[data.index].max, 'Zone ' + (data.index + 1) + ' Stats', items[data.index].area)">{{ data.value | toFixedSmall }}</span>
            <span v-if="isTimeHeader" class="clickable" @click="showKeyStats(items[data.index].min, items[data.index].max, 'Zone ' + (data.index + 1) + ' Stats', items[data.index].area)">{{ data.value | toDate }}</span>
          </template>
          <template #cell(area)="data">
            <span class="clickable" v-if="$store.state.userProfile.measurementSystem && $store.state.userProfile.measurementSystem === 'Metric'" @click="showKeyStats(items[data.index].min, items[data.index].max, 'Zone ' + (data.index + 1) + ' Stats', items[data.index].area)">{{ data.value | toHectares }} hectares</span>
            <span class="clickable" v-if="!$store.state.userProfile.measurementSystem || $store.state.userProfile.measurementSystem === 'Imperial'" @click="showKeyStats(items[data.index].min, items[data.index].max, 'Zone ' + (data.index + 1) + ' Stats', items[data.index].area)">{{ data.value | toAcres }} acres</span>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import KeyStats from './KeyStats'
const turf = require('@turf/turf')

export default {
  data () {
    return {
      items: [],
      fields: [
        {
          key: 'color',
          label: ''
        },
        {
          key: 'label',
          label: 'Zone'
        },
        {
          key: 'min',
          label: 'Min'
        },
        {
          key: 'max',
          label: 'Max'
        },
        {
          key: 'area',
          label: 'Area*'
        }
      ],
      mode: 'categorical',
      heatMap: false,
      minValue: 0,
      maxValue: 0,
      title: 'Key',
      collapsed: false,
      isTimeHeader: false
    }
  },
  components: {
    KeyStats
  },
  created () {
    this.initKey()
  },
  methods: {
    showKeyStats (min, max, label, area) {
      this.$store.commit('setStateProperty', { property: 'showKeyStats', value: false })
      this.$store.commit('setStateProperty', { property: 'keyStatsMin', value: min })
      this.$store.commit('setStateProperty', { property: 'keyStatsMax', value: max })
      this.$store.commit('setStateProperty', { property: 'keyStatsLabel', value: label })
      this.$store.commit('setStateProperty', { property: 'keyStatsArea', value: area })
      setTimeout(() => {
        this.$store.commit('setStateProperty', { property: 'showKeyStats', value: true })
      }, 30)
    },
    initKey () {
      this.$store.commit('setStateProperty', { property: 'showKeyStats', value: false })
      this.isTimeHeader = false
      if (this.$store.state.keyMode === 'blocks') {
        if (this.$store.state.farm.vizSettings) {
          const vizSettings = this.$store.state.farm.vizSettings
          // Guard against farms that haven't configured a colorHeader yet —
          // otherwise every reactive tick of farm.vizSettings with a raster
          // dataset active crashes Key.initKey.
          if (!vizSettings.colorHeader) return
          this.title = vizSettings.colorHeader.label
          if (vizSettings.colorBy === 'solid') {
            this.items.push({
              color: vizSettings.blockColor,
              percent: 100,
              label: 'Blocks'
            })
          } else if (vizSettings.colorBy === 'valueBased') {
            if (vizSettings.colorHeader.type === 'Date and Time') {
              this.isTimeHeader = true
            }
            if (vizSettings.colorHeader.type === 'Number' && vizSettings.zoneClassification === 'categorical') {
              vizSettings.featureCategories.forEach(category => {
                this.items.push({
                  color: category.color,
                  label: category.name
                })
              })
            } else if (vizSettings.colorHeader.type === 'Select') {
              vizSettings.colorHeader.options.forEach((category, i) => {
                this.items.push({
                  color: vizSettings.colors[i],
                  label: category
                })
              })
            } else if (vizSettings.colorHeader.type === 'Text') {
              vizSettings.featureCategories.forEach(category => {
                this.items.push({
                  color: category.color,
                  label: category.name
                })
              })
            } else if (vizSettings.zoneClassification === 'linear') {
              this.items.push({
                color: vizSettings.minColor,
                label: 'Min'
              },
              {
                color: vizSettings.maxColor,
                label: 'Max'
              })
              this.minValue = vizSettings.minValue
              this.maxValue = vizSettings.maxValue
              this.mode = 'ramp'
            } else if (vizSettings.zoneClassification === 'equal-interval' || vizSettings.zoneClassification === 'jenks') {
              for (let i = 0; i < vizSettings.zoneStops; i++) {
                const itemObj = {
                  color: vizSettings.colors[i],
                  percent: 100 / vizSettings.zoneStops,
                  label: 'Z' + (i + 1)
                }
                if (vizSettings.zoneClassification === 'equal-interval') {
                  const stopDiff = vizSettings.maxValue - vizSettings.minValue
                  const stopLength = 1 / vizSettings.zoneStops
                  const stopMultiplierMin = stopLength * i
                  const stopMultiplierMax = stopLength * (i + 1)
                  itemObj.min = (stopDiff * stopMultiplierMin) + vizSettings.minValue
                  itemObj.max = (stopDiff * stopMultiplierMax) + vizSettings.minValue
                }
                if (vizSettings.zoneClassification === 'jenks') {
                  itemObj.min = vizSettings.breaks[i]
                  itemObj.max = vizSettings.breaks[i + 1]
                }
                this.items.push(itemObj)
              }
              this.mode = 'zones'
            }
          }
        } else {
          this.items.push({
            color: '#6356a8',
            percent: 100,
            label: 'Blocks'
          })
        }
      } else if (this.$store.state.keyMode === 'dataset') {
        const vizSettings = this.$store.state.dataset.vizSettings || {}
        // colorHeader is literally `false` until a header is chosen — show
        // the dataset name rather than the word "false" as the key title.
        this.title = vizSettings.colorHeader || this.$store.state.dataset.name || 'Key'
        // Check to see if colorHeader is a date and time field
        if (this.$store.state.dataset.dynamic) {
          this.$store.state.collector.fields.forEach(field => {
            if (field.label === vizSettings.colorHeader && field.type === 'Date and Time') {
              this.isTimeHeader = true
            }
          })
        }
        if (vizSettings.type === 'heatMap') {
          this.heatMap = true
        } else if (vizSettings.type === 'circle') {
          if (vizSettings.colorBy === 'solid') {
            this.items.push(
              {
                color: vizSettings.circleColor,
                percent: 100,
                label: 'Datapoints'
              }
            )
          } else if (vizSettings.colorBy === 'valueBased') {
            if (vizSettings.categorical) {
              vizSettings.featureCategories.forEach(category => {
                this.items.push({
                  color: category.color,
                  label: category.name
                })
              })
            } else if (vizSettings.zoneClassification === 'linear') {
              this.minValue = vizSettings.minValue
              this.maxValue = vizSettings.maxValue
              this.items.push(
                {
                  color: vizSettings.minColor,
                  label: 'Min'
                },
                {
                  color: vizSettings.maxColor,
                  label: 'Max'
                }
              )
              this.mode = 'ramp'
            } else if (vizSettings.zoneClassification === 'equal-interval' || vizSettings.zoneClassification === 'jenks') {
              // Calculate total area of dataset
              const hull = turf.concave(this.$store.state.datasetGeoJson, { units: 'kilometers', maxEdge: 0.05 })
              const area = turf.area(hull)
              this.$store.commit('setStateProperty', { property: 'keyStatsTotalArea', value: area })
              const totalPointsCount = this.$store.state.datasetGeoJson.features.length

              for (let i = 0; i < vizSettings.zoneStops; i++) {
                const itemObj = {
                  color: vizSettings.colors[i],
                  percent: 100 / vizSettings.zoneStops,
                  label: i + 1
                }
                if (vizSettings.zoneClassification === 'equal-interval') {
                  const stopDiff = vizSettings.maxValue - vizSettings.minValue
                  const stopLength = 1 / vizSettings.zoneStops
                  const stopMultiplierMin = stopLength * i
                  const stopMultiplierMax = stopLength * (i + 1)
                  itemObj.min = (stopDiff * stopMultiplierMin) + vizSettings.minValue
                  itemObj.max = (stopDiff * stopMultiplierMax) + vizSettings.minValue
                }
                if (vizSettings.zoneClassification === 'jenks') {
                  itemObj.min = vizSettings.breaks[i]
                  itemObj.max = vizSettings.breaks[i + 1]
                }
                var zonePointsCount = 0
                this.$store.state.datasetGeoJson.features.forEach((feature, i) => {
                  // Note this small issues: the highest value in the dataset will never be counted toward the convace hull using this if statement
                  if (feature.properties[this.$store.state.dataset.vizSettings.colorHeader] >= itemObj.min && feature.properties[this.$store.state.dataset.vizSettings.colorHeader] < itemObj.max) {
                    zonePointsCount++
                  }
                })
                const countPercent = zonePointsCount / totalPointsCount
                const zoneArea = area * countPercent
                itemObj.area = zoneArea
                this.items.push(itemObj)
              }
              this.mode = 'zones'
            }
          }
        } else if (vizSettings.type === 'polygon') {
          console.log('Polygon')
          const vizSettings = this.$store.state.dataset.vizSettings
          console.log(vizSettings)
          if (vizSettings.colorBy === 'solid') {
            this.items.push({
              color: vizSettings.circleColor,
              percent: 100,
              label: 'Regions'
            })
          } else if (vizSettings.colorBy === 'valueBased') {
            if (vizSettings.colorHeader.type === 'Select') {
              vizSettings.colorHeader.options.forEach((category, i) => {
                this.items.push({
                  color: vizSettings.colors[i],
                  label: category
                })
              })
            } else if (vizSettings.zoneClassification === 'linear') {
              this.items.push({
                color: vizSettings.minColor,
                label: 'Min'
              },
              {
                color: vizSettings.maxColor,
                label: 'Max'
              })
              this.minValue = vizSettings.minValue
              this.maxValue = vizSettings.maxValue
              this.mode = 'ramp'
            } else if (vizSettings.zoneClassification === 'equal-interval' || vizSettings.zoneClassification === 'jenks') {
              for (let i = 0; i < vizSettings.zoneStops; i++) {
                const itemObj = {
                  color: vizSettings.colors[i],
                  percent: 100 / vizSettings.zoneStops,
                  label: 'Z' + (i + 1)
                }
                if (vizSettings.zoneClassification === 'equal-interval') {
                  const stopDiff = vizSettings.maxValue - vizSettings.minValue
                  const stopLength = 1 / vizSettings.zoneStops
                  const stopMultiplierMin = stopLength * i
                  const stopMultiplierMax = stopLength * (i + 1)
                  itemObj.min = (stopDiff * stopMultiplierMin) + vizSettings.minValue
                  itemObj.max = (stopDiff * stopMultiplierMax) + vizSettings.minValue
                }
                if (vizSettings.zoneClassification === 'jenks') {
                  itemObj.min = vizSettings.breaks[i]
                  itemObj.max = vizSettings.breaks[i + 1]
                }

                let area = 0
                const totalPolygonsCount = this.$store.state.datasetGeoJson.features.length
                var zonePolygonsCount = 0
                this.$store.state.datasetGeoJson.features.forEach((feature, i) => {
                  // Note this small issues: the highest value in the dataset will never be counted toward the convace hull using this if statement
                  if (feature.properties[this.$store.state.dataset.vizSettings.colorHeader] >= itemObj.min && feature.properties[this.$store.state.dataset.vizSettings.colorHeader] < itemObj.max) {
                    zonePolygonsCount++
                    const featureArea = turf.area(feature)
                    area = area + featureArea
                  }
                })
                const countPercent = zonePolygonsCount / totalPolygonsCount
                const zoneArea = area * countPercent
                itemObj.area = zoneArea
                this.items.push(itemObj)
              }
              this.mode = 'zones'
            }
          }
        } else if (vizSettings.type === 'line') {
          const lineViz = this.$store.state.dataset.vizSettings
          this.title = lineViz.colorHeader
          if (lineViz.colorBy === 'solid') {
            this.items.push({
              color: lineViz.circleColor,
              percent: 100,
              label: 'Lines'
            })
          } else if (lineViz.colorBy === 'valueBased') {
            if (lineViz.categorical) {
              lineViz.featureCategories.forEach(category => {
                this.items.push({
                  color: category.color,
                  label: category.name
                })
              })
            } else if (lineViz.zoneClassification === 'linear') {
              this.items.push({
                color: lineViz.minColor,
                label: 'Min'
              }, {
                color: lineViz.maxColor,
                label: 'Max'
              })
              this.minValue = lineViz.minValue
              this.maxValue = lineViz.maxValue
              this.mode = 'ramp'
            } else if (lineViz.zoneClassification === 'equal-interval' || lineViz.zoneClassification === 'jenks') {
              for (let i = 0; i < lineViz.zoneStops; i++) {
                this.items.push({
                  color: lineViz.colors[i],
                  percent: 100 / lineViz.zoneStops,
                  label: 'Z' + (i + 1)
                })
              }
              this.mode = 'zones'
            }
          }
        }
      }
    }
  },
  filters: {
    toDate (seconds) {
      var date = new Date(seconds * 1000) // Convert seconds to milliseconds

      // Extract the date components
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2) // Months are zero-based
      var day = ('0' + date.getDate()).slice(-2)

      // Create the readable date string in the desired format
      var dateString = `${month}-${day}-${year}`

      return dateString
    },
    toFixed (val) {
      function countDecimals (num) {
        if (!num) return 0
        if (Math.floor(num.valueOf()) === num.valueOf()) return 0
        return num.toString().split('.')[1].length || 0
      }
      if (Number.isInteger(val)) {
        return val
      } else {
        var decCount = countDecimals(val)
        if (decCount > 6) {
          return val.toFixed(6) + '...'
        } else {
          return val
        }
      }
    },
    toFixedSmall (val) {
      function countDecimals (num) {
        if (Math.floor(num.valueOf()) === num.valueOf()) return 0
        return num.toString().split('.')[1].length || 0
      }
      if (Number.isInteger(val)) {
        return val
      } else {
        var decCount = countDecimals(val)
        if (decCount > 5) {
          return val.toFixed(5) + '...'
        } else {
          return val
        }
      }
    },
    toAcres (val) {
      const acres = val * 0.000247105
      const rounded = acres.toFixed(2)
      return rounded
    },
    toHectares (val) {
      const hectares = val / 10000
      const rounded = hectares.toFixed(2)
      return rounded
    }
  }
}
</script>

<style scoped>
#key {
  position: absolute;
  bottom: 40px;
  right: 70px;
  width: 300px;
  background-color: #eee;
  border-radius: 4px;
  padding: 2px 4px;
  box-shadow: 1px 3px 6px rgba(0,0,0,0.3);
}

.collapse-button {
  font-size: 20px;
}

#key p {
  font-size: 14px;
}

span.heat-dot {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 20px;
  background: radial-gradient(red, lightblue, white);
  margin-bottom: -3px;
}

.color-dot {
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 12px;
}

.color-ramp {
  position: relative;
  min-width: 100px;
  margin-top: -6px;
}

.color-ramp-bar {
  display: inline-block;
  height: 10px;
  color: #eee;
  text-align: center;
  border-radius: 20px;
}

.color-bar {
  position: relative;
  width: 100%;
}

.color-bar-item {
  display: inline-block;
  height: 20px;
  text-align: center;
  font-size: 12px;
  padding-right: 2px;
}

.color-bar-item-color {
  width: 100%;
  height: 10px;
  border-radius: 10px;
}

.dot {
  width: 18px;
  height: 18px;
  border-radius: 30px;
}

@media(max-width:800px) {
  #key {
    position: absolute;
    bottom: 60px;
    right: 65px;
    max-width: 250px;
  }
}
</style>
